import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Column } from 'jspdf-autotable';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { ActivitiesDataService } from '../../services/activities-data.service';
import { ActivitiesColumnsService } from '../../services/activities-columns.service';
import { ToolsService } from '../../../services/tools/tools.service';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {

  public activities: any[] = [];
  public columns: any[] = [];
  public isLoading: boolean = false;
  public isInitialized: boolean = false;
  private _selectedColumns: Column[] = [];
  today: Date = new Date();
  public competition: any;

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private router: Router,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private activitiesDataService: ActivitiesDataService,
    private activitiesColumnsService: ActivitiesColumnsService,
  ) {
    const navigationH = this.router.getCurrentNavigation();
    console.log(navigationH);
    if (navigationH?.extras?.state) {
      this.competition = navigationH.extras.state.competitionReservation;
    } else {
      this.router.navigate(['/competition']);

    }
  }

  ngOnInit(): void {
    this.isInitialized = true;
    this.titleService.setTitle('Activities - Management');
    this.primengConfig.ripple = true;
    this.getActivities();
  }

  ngOnDestroy(): void {
    this.isInitialized = false;
  }

  getActivities(): void {
    this.isLoading = true;
    if (!this.isInitialized) {
      return;
    }
    this.activitiesDataService.getActivitiesByChallenge(this.competition.id).subscribe((response: any) => {
      this.isLoading = false;
      if (response !== null) {
        this.setColumns();
        this.activities = response.success;
      }
    }, (error: any) => {
      ;
      this.isLoading = false;
      this.messageService.add({ severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.CHALLENGESNOTLOADED') });
    });
  }

  setColumns() {
    if (this.columns.length > 0) {
      return;
    }
    this.columns = this.activitiesColumnsService.getColumns();
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].show) {
        this._selectedColumns.push(this.columns[i]);
      }
    }
  }

  @Input()
  get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    // restore original order
    this._selectedColumns = this.columns.filter((col: any) => val.includes(col));
    this.updateColumns();
  }

  updateColumns() {
    for (let i = 0; i < this.columns.length; i++) {
      const show = this._selectedColumns.includes(this.columns[i]);
      this.columns[i].show = show;
      this.navigation.setParamValue('challengeReservations.' + this.columns[i].field + '.showFiled', show);
    }
  }

  exportPdf() {
    ToolsService.exportPdf(this.activities, this.columns, 'Activities');
  }

  exportExcel() {
    ToolsService.exportExcel(this.activities, this.columns, 'Activities');
  }

  exportCsv() {
    ToolsService.exportCsv(this.activities, this.columns, 'Activities');
  }

  refresh() {
    this.getActivities();
  }


}
